import React from 'react';
import classNames from 'classnames';
import MediaUploaderWrapper from 'application/components/MediaUploaderWrapper';
import VideoMediaUploaderWrapper from 'application/components/VideoMediaUploaderWrapper';
import { ACCEPT_AUDIO_FILETYPES, ACCEPT_VIDEO_FILETYPES } from 'application/pages/constants';
import { AdCampaignMediaTypeEnum } from '@shared/api/graphql/generated';
import ExactTimeMediaUploader from '../ExactTimeMediaUploader';
import SortableAudioUploader from '../SortableAudioUploader';
import { TEXTS } from '../texts';
import { ELEMENT_IDS } from '../consts';
import styles from '../index.module.scss';
import { MediaUploadContentProps } from './types';

const MediaUploadContent: React.FC<MediaUploadContentProps> = ({
  inputRef,
  isExactTime,
  isDraggable,
  acceptValue,
  uploadButtonText,
  uploadDescription,
  items,
  player,
  mediaUploadItems,
  isUploadDisabled,
  handleUploadClick,
  handleFilesChange,
  handleFilesSelected,
  handleRemoveClick,
  handleRetryClick,
  handleRemoveMedia,
  handleRetryMedia,
  handleVideoMediaReorder,
  handlePlayClick,
  handleTimeBlur,
  reorder,
  mediaType,
  timeById,
  onTimeChange,
}) => (
  <div className={styles.root}>
    {!isExactTime && mediaType === AdCampaignMediaTypeEnum.Audio && isDraggable && (
      <SortableAudioUploader
        uploadButtonText={uploadButtonText}
        uploadDescription={uploadDescription}
        acceptValue={acceptValue}
        inputRef={inputRef}
        items={items}
        player={player}
        onUploadClick={handleUploadClick}
        onFilesChange={handleFilesChange}
        onPlayClick={handlePlayClick}
        onRemoveClick={handleRemoveClick}
        onRetryClick={handleRetryClick}
        onReorder={reorder}
      />
    )}

    {!isExactTime && mediaType === AdCampaignMediaTypeEnum.Audio && !isDraggable && (
      <MediaUploaderWrapper
        elementId={ELEMENT_IDS.UPLOADER}
        accept={ACCEPT_AUDIO_FILETYPES}
        items={mediaUploadItems}
        isLoading={false}
        buttonTitle={uploadButtonText}
        description={uploadDescription}
        uploaderHintText={TEXTS.INSTANT_UPLOAD_HINT}
        isUploadButtonDisabled={isUploadDisabled}
        multiple={false}
        onDrop={handleFilesSelected}
        onRemove={handleRemoveMedia}
        onRetry={handleRetryMedia}
        mediaUploaderClassname={styles.mediaUploader}
      />
    )}

    {!isExactTime && mediaType === AdCampaignMediaTypeEnum.Video && (
      <VideoMediaUploaderWrapper
        elementId={ELEMENT_IDS.UPLOADER}
        accept={ACCEPT_VIDEO_FILETYPES}
        items={mediaUploadItems}
        isLoading={false}
        buttonTitle={uploadButtonText}
        description={uploadDescription}
        onDrop={handleFilesSelected}
        onRemove={handleRemoveMedia}
        onRetry={handleRetryMedia}
        isSortable={isDraggable}
        onReorder={handleVideoMediaReorder}
        mediaUploaderClassname={classNames(
          styles.mediaUploader,
          mediaUploadItems.length === 0 && styles.mediaUploaderEmpty
        )}
      />
    )}

    {isExactTime && (
      <ExactTimeMediaUploader
        mediaType={mediaType}
        acceptValue={acceptValue}
        uploadButtonText={uploadButtonText}
        uploadDescription={uploadDescription}
        inputRef={inputRef}
        items={items}
        timeById={timeById}
        player={player}
        onUploadClick={handleUploadClick}
        onFilesChange={handleFilesChange}
        onTimeChange={onTimeChange}
        onTimeBlur={handleTimeBlur}
        onPlayClick={handlePlayClick}
        onRemoveClick={handleRemoveClick}
        onRetryClick={handleRetryClick}
        onReorder={reorder}
      />
    )}
  </div>
);

export default MediaUploadContent;
